import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// Define proper user state type
export interface UserState {
  id?: number;
  username?: string;
  email?: string;
  role?: string | { name?: string; is_admin?: boolean; permissions?: string[] };
  [key: string]: any; // Allow additional properties from API
}

const initialState: UserState | null = null;

const userData = createSlice({
  name: 'userData',
  initialState: initialState as UserState | null,
  reducers: {
    updateUserData: (_state, action: PayloadAction<UserState | null>) => {
      return action.payload;
    },
  },
});

export const { updateUserData } = userData.actions;
export default userData.reducer;
